import ReviewsIconCollectionManager from "@apps/reviews/utils/ReviewsIconCollectionManager";
import { InjectionKey } from "@lib/svelte-typed-context";

export const reviewsIconCollectionManagerContextToken = Symbol(
    "reviewsIconCollectionManagerContextToken"
) as InjectionKey<ReviewsIconCollectionManager>;
